import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import { NavigationService } from '../../navigation/navigation.service';

@Injectable()
export class AppAuthGuard extends KeycloakAuthGuard {
    constructor(
        protected router: Router,
        protected keycloakAngular: KeycloakService,
        private readonly navigationService: NavigationService
    ) {
        super(router, keycloakAngular);
    }

    isAccessAllowed(route: ActivatedRouteSnapshot): Promise<boolean> {
        return new Promise(resolve => {
            // Authenticated
            if (!this.authenticated) {
                // TODO discuss potential re-activation of internal "LoginPage"
                // this.navigationService.redirectToAnonymous();
                resolve(false);
                return;
            }

            // Roles
            const requiredRoles: string[] = route.data.roles;
            if (!requiredRoles || requiredRoles.length === 0) {
                resolve(true);
                return;
            }

            if (!this.roles || this.roles.length === 0) {
                this.navigationService.redirectToHome();
                resolve(false);
                return;
            }

            let granted = false;
            for (const requiredRole of requiredRoles) {
                if (this.roles.indexOf(requiredRole) > -1) {
                    granted = true;
                    break;
                }
            }
            if (!granted) {
                this.navigationService.redirectToHome();
                this.navigationService.redirectToAnonymous();
            }
            resolve(granted);
        });
    }
}
